<template>
  <div
    class="p_f t_h d_f ali_c"
    :class="isBg ? 'trans' : ''"
  >
    <div>
      <img
        src="../assets/img/th_back.png"
        alt=""
        class="cur_p back"
        @click="revert"
      >
    </div>
    <span class="t_a flex_1">{{ name }}</span>
    <div v-if="isShowText">
      <span
        v-if="isEdit"
        @click="$emit('edit')"
      >编辑</span>
      <span
        v-else
        @click="$emit('editCancel')"
      >取消</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TopHeadText",
    props:{
      name:{//标题
        type:String,
        default:''
      },
      isEdit:{//标题
        type:Boolean,
        default:false
      },
      isBg:{//标题
        type:Boolean,
        default:false
      },
      isShowText:{//标题
        type:Boolean,
        default:false
      },
    },
    beforeUnmount(){
      this.isDestroyed = true;
    },
    data() {
      return {

        isDestroyed:false,
      }
    },
    methods: {
      backApp(){
        localStorage.removeItem('map');
        // localStorage.clear()
        if(this.$global.modelState){
          window.android.exit();
        }else {
          this.$iosMethod(function(bridge) {
            bridge.callHandler('exit', null,function(data) {

            })
          })
        }
      },
      revert(){
        if (window.history.length <= 1) {
          this.backApp()
          return false
        } else {
          this.$router.go(-1)
        }
        //上面都没执行就说明卡在当前页不是最后一条， histroy记录数量大于1，又没有回退记录，只能返回首页，
        //如果上面都执行了 页面都跳走了，这个也就不用管了

        setTimeout(() => {
          console.log(this.isDestroyed)
          if(this && !this.isDestroyed){//isDestroyed 组件是否被销毁
            console.log('this.isDestroyed)')
            this.backApp()
          }
        },1000)
      },
    }
  }
</script>

<style scoped lang="scss">
  .t_h{
    border-bottom: 1PX solid #f5f5f5;
    &.trans{
      border-bottom: none;
      background: transparent;
    }
    .share{
      width: 30px;
      height: 30px;
    }
    .back{
      width: 19px;
      height: 34px;
    }
    >div{
      span{
        font-size: 26px;
        font-weight: bold;
        color: #3E3E3E;
      }
      width: 60px;
    }
    font-size: 36px;
    font-weight: bold;
    color: #3E3E3E;
    height: 85px;
    width: 100%;
    background-color: white;
    left: 0;
    top: 0;
    z-index: 100000;
    padding: 29px 25px;
    box-sizing: border-box;
  }

</style>
